import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import NewLayoutContent from './_NewLayoutContent'

const ProductUpdateDetailPage = () => {
  const { slug } = useParams()

  if (!slug) return null

  return (
    <ResponsivePage.Body showHeader={false} variant="narrow">
      <Box maxWidth="narrowPage" alignSelf="center">
        <NewLayoutContent slug={slug} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default ProductUpdateDetailPage
